import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import { LoaderProvider } from '../loader/loader';
import { SessionProvider } from '../session/session';
import { ConfigProvider } from '../config/config';

/*
  Generated class for the RequestProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RequestProvider {

  constructor(
    public http: HttpClient,
    private translate: TranslateService,
    private sessionService: SessionProvider,
    private loader: LoaderProvider,
    private config: ConfigProvider
  ) { }

  basicErrorHandle() {
    return error => {
      return error.flatMap((error: any) => {
        console.log(error);
        if (error.status === 0) {
          let elem = document.querySelector('div.loading-content');

          if (elem) elem.innerHTML = this.translate.instant('GLOBAL_ERROR_CANNOT_CONNECT');

          return Observable.of(error.status).delay(2000);
        } else if (error.status === 500) {
          return Observable.throw({ error: '500 from server' });
        } else if (error.status === 404) {
          let elem = document.querySelector('div.loading-content');

          if (elem) elem.innerHTML = this.translate.instant('GLOBAL_ERROR_SERVER_IS_UNREACHABLE');

          return Observable.of(error.status).delay(2000);
        } else if (error.status === 400) {
          this.loader.dismissAll();
          return Observable.throw({ error: 'No retry ' + error.status });
        } else if (error.status !== 200) {
          return Observable.of(error.status).delay(1000);
        }
        return Observable.throw({ error: 'No retry ' + error.status });
      });
    };
  }

  actualErrorHandler() {
    return error => {
      return error.flatMap((error: any) => {
        console.log(error);
        if (error.status === 0) {
          return Observable.of(error.status).delay(2000);
        } else if (error.status === 500) {
          return Observable.throw({ error: '500 from server' });
        } else if (error.status === 404) {
          let elem = document.querySelector('div.loading-content');

          if (elem) elem.innerHTML = this.translate.instant('GLOBAL_ERROR_SERVER_IS_UNREACHABLE');

          return Observable.of(error.status).delay(2000);
        } else if (error.status === 400) {
          this.loader.dismissAll();
          return Observable.throw({ error: 'No retry ' + error.status });
        } else if (error.status !== 200) {
          return Observable.of(error.status).delay(1000);
        }
        return Observable.throw({ error: 'No retry ' + error.status });
      });
    };
  }

  get(
    url: string,
    options?: {
      headers?:
      | HttpHeaders
      | {
        [header: string]: string | string[];
      };
      observe?: 'body';
      params?:
      | HttpParams
      | {
        [param: string]: string | string[];
      };
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
    }
  ): Observable<Object> {
    return (
      this.http
        .get(url, options)
        //.retryWhen(this.basicErrorHandle())
        .catch((err: any) => {
          if (err.status === 400 || err.status === 401) {
            alert(err.error.message);
            return null;
          }
        })
    );
  }

  post(
    url: string,
    body: any | null,
    options?: {
      headers?:
      | HttpHeaders
      | {
        [header: string]: string | string[];
      };
      observe?: 'body';
      params?:
      | HttpParams
      | {
        [param: string]: string | string[];
      };
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
    }
  ): Observable<Object> {
    return this.http.post(url, body, options).catch(err => {
      if (err.status === 400 || err.status === 401) {
        alert(err.error.message);
        return null;
      }
    })
  }

  public async postWithToken<T>(url: string, body: any | null, obj?: any, first: boolean = false, profileRequired: boolean = true): Promise<T> {
    if (!obj) obj = {};
    if (!body) body = {};
    let httpParams = new HttpParams();
    await this.sessionService.getToken(first, profileRequired).then(async (token: string) => {
      httpParams = httpParams.append('token', token);
    });
    obj.httpParams = httpParams;
    return this.createPostPromise<T>(url, body, obj);
  }

  createPostPromise<T>(url: string, body: any, obj: any): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      let httpParams = new HttpParams({ fromObject: obj });
      this.post(url, body, { params: httpParams })
        .toPromise()
        .then((value: T) => {
          resolve(value);
        })
        .catch((value: T) => {
          if (value instanceof Boolean) {
            resolve(value);
          } else {
            resolve(null);
          }
        });
    });
  }

  public async getApiWithToken<T>(
    path: string,
    obj?: any,
    first: boolean = false,
    profileRequired: boolean = true,
    timeout: number = 30000,
    target: string = 'baseUrl'
  ): Promise<T> {
    if (!obj) obj = {};
    let token = await this.sessionService.getToken(first, profileRequired);
    obj.token = token;
    return this.createGetApiPromise<T>(path, timeout, obj, target);
  }

  getSimple<T>(url: string, obj?: any, timeout = 30000): Promise<T> {
    if (!obj) obj = {};
    return this.createGetPromise<T>(url, timeout, obj);
  }

  public getApiSimple<T>(path: string, obj?: any, timeout = 30000, target: string = 'baseUrl'): Promise<T> {
    if (!obj) obj = {};
    return this.createGetApiPromise<T>(path, timeout, obj, target);
  }

  async createPostApiPromiseOwn<T>(
    path: string,
    body: any | null,
    options?: {
      headers?:
      | HttpHeaders
      | {
        [header: string]: string | string[];
      };
      observe?: 'body';
      params?:
      | HttpParams
      | {
        [param: string]: string | string[];
      };
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
    },
    target: string = 'baseUrl'
  ) {
    // let call = async (target, path, body, options) => {

    let url = path;

    return this.http.post<T>(url, body, options).catch(err => {
      if (err.status === 400 || err.status === 401) {
        alert(err.error.message);
        return null;
      }
      // if (err.status === 0 || err.status === 500 || err.status === 404) {
      //   return await new Promise(resolve => setTimeout(async () => resolve(await call(target, path, body, options))));
      // } else throw err;
    });
    // };

    // return this.unpack<T>((await call(target, path, body, options)).toPromise());
  }

  public getApiOwnPath<T>(path: string, obj?: any, timeout = 30000): Promise<T> {
    if (!obj) obj = {};
    return this.createGetApiPromiseOwnPath<T>(path, timeout, obj);
  }

  public async getWithToken<T>(url: string, obj?: any, first: boolean = false, profileRequired: boolean = true, timeout: number = 30000): Promise<T> {
    if (!obj) obj = {};
    let token = await this.sessionService.getToken(first, profileRequired);
    obj.token = token;
    return this.createGetPromise<T>(url, timeout, obj);
  }

  private async createGetApiPromiseOwnPath<T>(path: string, timeout: number, obj?: any, isSigned: boolean = false, isNullable: boolean = false): Promise<T> {
    let params = new HttpParams({ fromObject: obj });

    // let call = async (path, params) => {

    return this.http.get<T>(path, { params: params }).toPromise().catch(err => {
      if (err.status === 400 || err.status === 401) {
        alert(err.error.message);
        return null;
      }
      // if (err.status === 0) {
      //   return await new Promise(resolve => {
      //     setTimeout(async () => {
      //       resolve(await call(path, params));
      //     }, 2000)
      //   });
      // };
    });
    // };
    // return this.unpack<T>((await call(path, params)).toPromise());
  }

  public async createGetApiPromise<T>(path: string, timeout: number, obj?: any, target: string = 'baseUrl'): Promise<T> {
    let params = new HttpParams({ fromObject: obj });
    let url = (await this.config.urlConfig())[target];
    
    return this.http.get<T>(url + path, { params: params }).toPromise().catch(err => {
      if (err.status === 400 || err.status === 401) {
        alert(err.error.message);
        return null;
      }
    });
  }

  async createPostApiPromise<T>(
    path: string,
    body: any | null,
    options?: {
      headers?:
      | HttpHeaders
      | {
        [header: string]: string | string[];
      };
      observe?: 'body';
      params?:
      | HttpParams
      | {
        [param: string]: string | string[];
      };
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
    },
    target: string = 'baseUrl'
  ) {
    let url = (await this.config.urlConfig())[target];
    return this.http.post<T>(url + path, body, options).toPromise().catch((err: HttpErrorResponse) => {
      if (err.status === 400 || err.status === 401) {
        alert(err.error.message);
        return null;
      }
    });
  }

  private unpack<T>(pro: Promise<any>): Promise<T> {
    return pro.then(async content => {
      let ret = content;
      while (ret instanceof Observable) {
        ret = await ret.toPromise();
      }
      return ret as T;
    });
  }

  createGetPromise<T>(url: string, timeout: number, obj?: any, isNullable: boolean = false): Promise<T> {
    let params = new HttpParams({ fromObject: obj });
    return this.get(url, { params: params })
      .toPromise()
      .then((values: T) => {
        return values;
      })
      .catch(error => {
        if (isNullable) {
          return null;
        } else {
          throw 'cannot get ' + url;
        }
      });
  }
}



// WEBPACK FOOTER //
// /src/providers/request/request.ts